import styled from "styled-components";

export default styled.li`
  display: inline-block;
  vertical-align: middle;
  margin-right: ${props => (props.isBigSize ? "16px" : "10px")};
`;
